import * as React from 'react';
import styled from 'styled-components';
import {CoursePromoContext} from '../context';

const Image = styled.img`
  height: 100%;
  min-width: 100%;
  object-fit: cover;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 680px;
  overflow: hidden;
`;

/**
 * The course promo cover component
 * @return {React.ReactElement}
 * @constructor
 */
export default function CoursePreview(): React.ReactElement {
  const context = React.useContext(CoursePromoContext);

  return (
    <Content>
      <Image src={context?.preview?.cover}/>
    </Content>
  );
}
